import gql from 'graphql-tag'

export const GET_PARTS = gql`
  query Parts($filter: GetPartsFilter) {
    parts(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      parts {
        data {
          code
          description
          name
          price
          quality
          sku
          unit
          partTypeId
          partType {
            partTypeId
            type
            partCategoryId
            partCategory {
              partCategoryId
              category
            }
          }
          partId
          partBrandId
          partBrand {
            brand
            partBrandId
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_PART_BY_ID = gql`
  query Part($filter: GetPartFilter!) {
    part(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      part {
        code
        description
        name
        price
        sku
        quality
        unit
        partId
        partTypeId
        partBrandId
        partType {
          partTypeId
          type
          partCategoryId
          partCategory {
            partCategoryId
            category
          }
        }
        partBrand {
          brand
          partBrandId
        }
      }
    }
  }
`

export const CREATE_PART = gql`
  mutation CreatePart($input: CreatePartInput!) {
    createPart(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createPart {
        partId
      }
    }
  }
`

export const UPDATE_PART = gql`
  mutation UpdatePart($input: UpdatePartInput!) {
    updatePart(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const DELETE_PART = gql`
  mutation DeletePart($input: DeletePartInput!) {
    deletePart(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`
